import { render, staticRenderFns } from "./SortingDraftForm.vue?vue&type=template&id=dce0396c"
import script from "./SortingDraftForm.vue?vue&type=script&lang=js"
export * from "./SortingDraftForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports